// extracted by mini-css-extract-plugin
export default {"container":"style_container__hv9k7","point":"style_point__U+R71","animate":"style_animate__RbRyc"};